<template>
  <basic-page
    :title="pageTitle"
    :prev="true"
    :fallback="{ name: 'Leirikoski', query: { tab: 'vihko' } }"
  >
    <v-row class="fill-height">
      <v-col cols="12" lg="10" offset-lg="1" offset-xl="2" xl="8">
        <v-card :loading="loading">
          <v-card-title>
            <v-icon left>mdi-notebook-outline</v-icon>
            {{ pageTitle }}
          </v-card-title>
          <v-divider />
          <v-card-text v-if="vihkoData">
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <modal-picker
                  v-model="vihkoData.viikko"
                  :allowed-dates="allowedDates"
                  :disabled="!canEdit"
                  :show-clear="false"
                  label="Viikko"
                  type="week"
                >
                  <template v-slot:append="">
                    <v-btn
                      v-if="canEdit"
                      :ripple="false"
                      class="mt-n1"
                      depressed
                      plain
                      text
                      @click="vihkoData.viikko = todayDate"
                      >Tänään
                    </v-btn>
                  </template>
                </modal-picker>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <modal-picker
                  v-model="vihkoData.tarkastus"
                  :allowed-dates="allowedDates"
                  :disabled="!canEdit"
                  :hide-details="false"
                  hint="Olet tarkastanut alueen yleisen siisteyden (piha-alue, koulutusrakennus, saunarakennus, kota) ja tehnyt tarvittavat toimenpiteet."
                  label="Alueen siisteyden tarkastus"
                  persistent-hint
                >
                  <template v-slot:append="">
                    <v-btn
                      v-if="canEdit"
                      :ripple="false"
                      class="mt-n1"
                      depressed
                      plain
                      text
                      @click="vihkoData.tarkastus = todayDate"
                      >Tänään
                    </v-btn>
                  </template>
                </modal-picker>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <modal-picker
                  v-model="vihkoData.ovienAvaus"
                  :allowed-dates="allowedDates"
                  :disabled="!canEdit"
                  :hide-details="false"
                  hint="Olet avannut ovet asiakkaalle sekä mahdollisesti esitellyt paikat."
                  label="Ovien avaus asiakkaalle"
                  persistent-hint
                >
                  <template v-slot:append="">
                    <v-btn
                      v-if="canEdit"
                      :ripple="false"
                      class="mt-n1"
                      depressed
                      plain
                      text
                      @click="vihkoData.ovienAvaus = todayDate"
                      >Tänään
                    </v-btn>
                  </template>
                </modal-picker>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <modal-picker
                  v-model="vihkoData.tarkastusAsiakas"
                  :allowed-dates="allowedDates"
                  :disabled="!canEdit"
                  :hide-details="false"
                  hint="Olet tarkastanut piha-alueen, koulutusrakennuksen, saunarakennuksen asiakkaan jälkeen."
                  label="Siisteyden tarkastus asiakkaan jälkeen"
                  persistent-hint
                >
                  <template v-slot:append="">
                    <v-btn
                      v-if="canEdit"
                      :ripple="false"
                      class="mt-n1"
                      depressed
                      plain
                      text
                      @click="vihkoData.tarkastusAsiakas = todayDate"
                      >Tänään
                    </v-btn>
                  </template>
                </modal-picker>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <modal-picker
                  v-model="vihkoData.poreallas"
                  :allowed-dates="allowedDates"
                  :disabled="!canEdit"
                  :hide-details="false"
                  hint="Olet hoitanut porealtaan, mitannut kloorin ja pH:n, sekä laittanut klooritabletit kellujaan, sekä tarvittaessa lisännyt raekloorin. Tarvittaessa vaihtanut veden, pessyt suodattimen tai vaihtanut sen. Olet merkinnyt kaikki altaalle tehdyt toimenpiteet Poreallas-välilehdellä!"
                  label="Porealtaan hoito"
                  persistent-hint
                >
                  <template v-slot:append="">
                    <v-btn
                      v-if="canEdit"
                      :ripple="false"
                      class="mt-n1"
                      depressed
                      plain
                      text
                      @click="vihkoData.poreallas = todayDate"
                      >Tänään
                    </v-btn>
                  </template>
                </modal-picker>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <modal-picker
                  v-model="vihkoData.lumet"
                  :allowed-dates="allowedDates"
                  :disabled="!canEdit"
                  :hide-details="false"
                  hint="Olet aurannut ja luonut lumet piha-alueelta sekä terassilta. Tarvittaessa hiekoittanut kulkuväylät. Ilmoittanut isännöitsijälle yli 10cm lumesta."
                  label="Auraus ja lumien luonti"
                  persistent-hint
                >
                  <template v-slot:append="">
                    <v-btn
                      v-if="canEdit"
                      :ripple="false"
                      class="mt-n1"
                      depressed
                      plain
                      text
                      @click="vihkoData.lumet = todayDate"
                      >Tänään
                    </v-btn>
                  </template>
                </modal-picker>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <modal-picker
                  v-model="vihkoData.nurmikko"
                  :allowed-dates="allowedDates"
                  :disabled="!canEdit"
                  :hide-details="false"
                  hint="Olet leikannut alueen nurmikon."
                  label="Nurmikon leikkaus"
                  persistent-hint
                >
                  <template v-slot:append="">
                    <v-btn
                      v-if="canEdit"
                      :ripple="false"
                      class="mt-n1"
                      depressed
                      plain
                      text
                      @click="vihkoData.nurmikko = todayDate"
                      >Tänään
                    </v-btn>
                  </template>
                </modal-picker>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <modal-picker
                  v-model="vihkoData.takka"
                  :allowed-dates="allowedDates"
                  :disabled="!canEdit"
                  :hide-details="false"
                  hint="Olet lämmittänyt takan kylmillä keleillä."
                  label="Takan lämmitys"
                  persistent-hint
                >
                  <template v-slot:append="">
                    <v-btn
                      v-if="canEdit"
                      :ripple="false"
                      class="mt-n1"
                      depressed
                      plain
                      text
                      @click="vihkoData.takka = todayDate"
                      >Tänään
                    </v-btn>
                  </template>
                </modal-picker>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-text-field
                  v-model.number="vihkoData.tunnit"
                  :disabled="!canEdit"
                  hint="Kuinka monta tuntia käytit aikaa Leirikoskella tai siihen liittyvissä tehtävissä."
                  label="Tuntimäärä"
                  outlined
                  persistent-hint
                  type="number"
                />
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-textarea
                  v-model="vihkoData.huomiot"
                  :disabled="!canEdit"
                  auto-grow
                  hint="Kerro tässä mitä teit ja mitä huomasit. Jos teit jotain muuta kuin yllä mainitut tehtävät, kerro se tässä."
                  label="Huomiot / muut tehdyt työt"
                  outlined
                  persistent-hint
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card v-if="checklist.length > 0" class="mt-5">
          <v-card-title>
            <v-icon left>mdi-clipboard-check-outline</v-icon>
            Siisteyden tarkastus
            <v-spacer />
            <v-chip small
              >{{ checklistDoneCount }} / {{ checklistCount }}</v-chip
            >
          </v-card-title>
          <v-divider />
          <v-card-text>
            <div v-if="canEdit" class="text-caption mb-2">
              Paina kuvaketta vaihtaaksesi tilaa: kunnossa
              <v-icon small class="green--text">mdi mdi-check</v-icon>, huomio
              <v-icon small class="orange--text"
                >mdi mdi-exclamation-thick</v-icon
              >, vika <v-icon small class="red--text">mdi mdi-alert</v-icon>.
            </div>
            <template v-for="(item, i) in checklist">
              <v-row :key="item.id">
                <template v-if="item.type === 'title'">
                  <v-col
                    class="align-center justify-space-between mt-5 mb-2 border-bottom"
                    cols="12"
                  >
                    <span class="text-subtitle-1 font-weight-bold">{{
                      item.title
                    }}</span>
                  </v-col>
                </template>
                <template v-else>
                  <v-col
                    :class="[
                      'd-flex align-center justify-space-between py-1',
                      item.done === 2 && 'green lighten-5 green--text',
                      item.done === 1 && 'orange lighten-5 orange--text',
                      item.done === 0 && 'red lighten-5 red--text',
                      'border-bottom',
                    ]"
                    cols="9"
                  >
                    <span class="text-subtitle-2">
                      {{ item.title }}
                      <v-icon
                        v-if="item.done === 2"
                        class="green lighten-5 green--text"
                        >mdi mdi-check
                      </v-icon>
                      <v-icon
                        v-if="item.done === 1"
                        class="orange lighten-5 orange--text"
                        >mdi mdi-exclamation-thick
                      </v-icon>
                      <v-icon
                        v-if="item.done === 0"
                        class="red lighten-5 red--text"
                        >mdi mdi-alert
                      </v-icon>
                    </span>
                  </v-col>
                  <v-col
                    v-if="canEdit"
                    :class="[
                      'd-flex align-center py-1',
                      item.done === 2 && 'green lighten-5 green--text',
                      item.done === 1 && 'orange lighten-5 orange--text',
                      item.done === 0 && 'red lighten-5 red--text',
                      'border-bottom',
                      'justify-end',
                    ]"
                    cols="3"
                  >
                    <v-btn
                      v-if="!item.done && item.done !== 0"
                      icon
                      @click="updateStatus(i, 2)"
                    >
                      <v-icon>mdi mdi-check</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.done === 2"
                      icon
                      @click="updateStatus(i, 1)"
                    >
                      <v-icon>mdi mdi-check</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.done === 1"
                      icon
                      @click="updateStatus(i, 0)"
                    >
                      <v-icon>mdi mdi-check</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.done === 0"
                      icon
                      @click="updateStatus(i, null)"
                    >
                      <v-icon>mdi mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </template>
              </v-row>
            </template>
            <v-row class="mt-6">
              <v-col cols="12">
                <v-textarea
                  v-model="vihkoData.siisteystarkastusHuomiot"
                  :disabled="!canEdit"
                  auto-grow
                  hint="Tarkenna tässä havaitut huomiot ja viat sekä tekemäsi toimenpiteet."
                  label="Siisteyden tarkastuksen huomiot"
                  outlined
                  persistent-hint
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-actions>
            <v-btn
              v-if="canEdit && vihkoData && vihkoData.id"
              :loading="loadingDelete"
              color="error"
              @click="deleteVihko"
              >Poista
            </v-btn>
            <v-spacer />
            <v-btn color="error" text @click="cancel">
              {{ canEdit ? "Peruuta" : "Takaisin" }}
            </v-btn>
            <v-btn
              v-if="canEdit"
              :loading="saving"
              color="primary"
              @click="save"
              >Tallenna
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </basic-page>
</template>

<script>
import BasicPage from "@/components/BasicPage";
import ModalPicker from "@/components/ModalPicker";
import dayjs from "dayjs";
import { addDoc, collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { firestore as db } from "@/plugins/firebase.app";

export default {
  name: "LeirikoskiVihkoEdit",
  components: { BasicPage, ModalPicker },
  data: () => ({
    loading: false,
    saving: false,
    loadingDelete: false,
    vihkoData: null,
    checklist: [],
  }),
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
    canEdit() {
      if (!this.isEdit) return true;
      return this.vihkoData?.createdBy?.sub === this.$userDBContext.sub;
    },
    pageTitle() {
      if (!this.isEdit) return "Uusi kiinteistöpäivystäjän vihon merkintä";
      return this.canEdit
        ? "Muokkaa kiinteistöpäivystäjän vihon merkintää"
        : "Kiinteistöpäivystäjän vihon merkintä";
    },
    todayDate() {
      return dayjs().format("YYYY-MM-DD");
    },
    today() {
      return dayjs();
    },
    checklistItems() {
      return this.checklist.filter((i) => i.type !== "title");
    },
    checklistCount() {
      return this.checklistItems.length;
    },
    checklistDoneCount() {
      return this.checklistItems.filter(
        (i) => i.done === 2 || i.done === 1 || i.done === 0,
      ).length;
    },
  },
  async created() {
    this.loading = true;
    const template = await this.loadTemplate();
    if (this.isEdit) {
      await this.loadVihko();
    } else {
      this.vihkoData = {
        viikko: this.todayDate,
        tunnit: null,
        name: null,
        poreallas: null,
        lumet: null,
        nurmikko: null,
        ovienAvaus: null,
        tarkastus: null,
        tarkastusAsiakas: null,
        takka: null,
        huomiot: null,
        siisteystarkastusHuomiot: null,
      };
    }
    this.checklist = this.mergeChecklist(
      this.vihkoData?.siisteystarkastus || [],
      template,
    );
    this.loading = false;
  },
  methods: {
    allowedDates(val) {
      return this.today.isSameOrAfter(val, "day");
    },
    async loadTemplate() {
      try {
        const snapshot = await getDoc(
          doc(db, "leirikoski_vihko_settings", "siisteystarkastus"),
        );
        return snapshot.exists() ? snapshot.data().items || [] : [];
      } catch (e) {
        console.error(e);
        this.$toast("Tarkastuslistan haku epäonnistui", { type: "error" });
        return [];
      }
    },
    async loadVihko() {
      try {
        const snapshot = await getDoc(
          doc(db, "kiinteistopaivystaja_vihko", this.$route.params.id),
        );
        if (!snapshot.exists() || snapshot.data().deleted) {
          this.$toast("Merkintää ei löytynyt", { type: "error" });
          this.cancel();
          return;
        }
        const data = { id: snapshot.id, ...snapshot.data() };
        if (
          data.createdBy?.sub !== this.$userDBContext.sub &&
          !this.$isVihkoSeuranta
        ) {
          this.$toast("Et voi muokata toisen käyttäjän tallentamaa vihkoa", {
            type: "error",
          });
          this.cancel();
          return;
        }
        this.vihkoData = {
          siisteystarkastusHuomiot: null,
          ...data,
        };
      } catch (e) {
        console.error(e);
        this.$toast("Kiinteistöpäivystäjän vihon haku epäonnistui", {
          type: "error",
        });
        this.cancel();
      }
    },
    // Saved answers win, template defines order; items dropped from the template stay visible on old entries.
    mergeChecklist(saved, template) {
      const merged = template.map((t) => {
        const previous = saved.find((s) => s.id === t.id);
        return {
          id: t.id,
          title: t.title,
          type: t.type || null,
          done: previous?.done ?? null,
        };
      });
      const orphans = saved.filter((s) => !template.some((t) => t.id === s.id));
      return [...merged, ...orphans];
    },
    updateStatus(index, status) {
      this.$set(this.checklist[index], "done", status);
    },
    cancel() {
      this.$router.push({ name: "Leirikoski", query: { tab: "vihko" } });
    },
    async save() {
      this.saving = true;
      try {
        const payload = {
          ...this.vihkoData,
          siisteystarkastus: this.checklist,
          createdBy: this.$userDBContext,
          createdAt: Date.now(),
          deleted: false,
        };
        if (this.vihkoData.id) {
          delete payload.id;
          await updateDoc(
            doc(db, "kiinteistopaivystaja_vihko", this.vihkoData.id),
            payload,
          );
        } else {
          await addDoc(collection(db, "kiinteistopaivystaja_vihko"), payload);
        }
        this.$toast("Kiinteistöpäivystäjän vihon tallennus onnistui", {
          type: "success",
        });
        this.cancel();
      } catch (e) {
        console.error(e);
        this.$toast("Kiinteistöpäivystäjän vihon tallennus epäonnistui", {
          type: "error",
        });
      }
      this.saving = false;
    },
    async deleteVihko() {
      if (
        !(await this.$deleteConfirm(
          "Haluatko varmasti poistaa vihon merkinnän?",
        ))
      ) {
        return;
      }
      this.loadingDelete = true;
      try {
        await updateDoc(
          doc(db, "kiinteistopaivystaja_vihko", this.vihkoData.id),
          { deleted: true },
        );
        this.$toast("Vihon merkintä poistettu", { type: "success" });
        this.cancel();
      } catch (e) {
        console.error(e);
        this.$toast("Vihon merkinnän poisto epäonnistui", { type: "error" });
      }
      this.loadingDelete = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
